import { Typography } from '@cobliteam/ui/components';
import ButtonToggle from '@cobliteam/ui/components/ButtonToggle';
import Icon from '@cobliteam/ui/icons';
import type React from 'react';
import type { Boundaries, TimePreset } from '../types';

interface TimePresetsProps {
  timePresets: TimePreset[];
  selectedPreset: TimePreset | null;
  boundaries: Boundaries;
  onPresetSelect: (preset: TimePreset) => void;
}

const TimePresets: React.FC<TimePresetsProps> = ({ timePresets, selectedPreset, boundaries, onPresetSelect }) => {
  return (
    <div className='flex flex-col gap-2'>
      <div className='flex items-center justify-between'>
        <Typography variant='text-sm-medium' color='default'>
          Períodos rápidos
        </Typography>
        <div className='flex gap-4 font-medium text-xs'>
          <div className='flex items-center gap-1'>
            <div className='size-2 rounded-full bg-primary' />
            <span>Início: {boundaries.min}</span>
          </div>
          <div className='flex items-center gap-1'>
            <div className='size-2 rounded-full bg-gray-11' />
            <span>Fim: {boundaries.max}</span>
          </div>
        </div>
      </div>
      <div className='grid grid-cols-2 gap-2'>
        {timePresets.map((preset) => (
          <ButtonToggle
            key={preset.label}
            size='sm'
            pressed={selectedPreset?.label === preset.label}
            startIcon={preset.icon ? <Icon name={preset.icon as any} /> : undefined}
            onPressedChange={() => onPresetSelect(preset)}
            className='justify-start text-xs'
          >
            {preset.label}
          </ButtonToggle>
        ))}
      </div>
    </div>
  );
};

export default TimePresets;
